import { useOutletContext } from "react-router-dom";
import VasorumMainDashboard from "./MainDashboards/VasorumMainDashboard";
import VantisMainDashboard from "./MainDashboards/VantisMainDashboard";

const dashboardByCompany = {
  vasorum: VasorumMainDashboard,
  vantis: VantisMainDashboard,
};

export default function MainDashboard() {
  const { companyId } = useOutletContext();

  const DashboardComponent =
    dashboardByCompany[companyId] || null;

  return <DashboardComponent />;
}
